import { render, staticRenderFns } from "./EcommerceCommissions.vue?vue&type=template&id=5c7e36b1&"
import script from "./EcommerceCommissions.vue?vue&type=script&lang=js&"
export * from "./EcommerceCommissions.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceCommissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports